exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown .dropdown-menu[data-v-35607e06]{width:350px}.dropdown .dropdown-menu .note[data-v-35607e06]{overflow-y:auto;max-height:200px}", ""]);

// exports
